import { useState, useEffect } from "react";
import { Container, Tab, Tabs, Table, Pagination } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import Loader from "../utilComponents/loader.js";
import ShimmerLoader from "../utilComponents/shimmer.js";
import { useDeposits } from "../../services/hooks/getApi";
import instance from "../../services/endpoint";
import { useNavigate } from "react-router-dom";
import "../../styles/history.css";

const OrderHistoryPage = () => {
  const navigate = useNavigate();
  const [modalImage, setModalImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const [loading, setLoading] = useState(false);

  const { data, isLoading, refetch } = useDeposits();
  const depositHistory = data?.deposits?.reverse() || [];
  const totalInvestment = data?.Investment || 0;

  console.log("Deposit History:", depositHistory);
  // console.log("oldaged", depositHistory[0]?.oldaged);
  useEffect(() => {
    document.title = "Order History | Bitstek Advisory";
  }, []);

  const withdrawReq = async (
    deposit_mode,
    returnAmount,
    id,
    depositedAmount,
    particularReturn,
    month
  ) => {
    setLoading(true);
    if (
      !deposit_mode ||
      !returnAmount ||
      !id ||
      !depositedAmount ||
      !particularReturn ||
      !month
    ) {
      toast.error("Missing required fields.");
      return;
    }

    const payload = {
      withdraw_mode: deposit_mode,
      amount: returnAmount,
      id: id,
      depositedAmount,
      particularReturn,
      month,
    };

    try {
      const response = await instance.post("/api/v1/withdraw", payload);
      await refetch();
      Swal.fire({
        title: "Success",
        text: response.data.message,
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Error sending withdraw request."
      );
      console.error("Withdraw request error:", error);
    } finally {
      setLoading(false);
    }
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = depositHistory.slice(
    startIndex,
    startIndex + itemsPerPage
  );
  const totalPages = Math.ceil(depositHistory.length / itemsPerPage);

  // modal functions===================
  const openModal = (image) => {
    console.log("Opening modal with image:", image);
    setModalImage(image); // Set the image source for the modal
    setIsModalOpen(true); // Open the modal
  };

  const closeModal = () => {
    setIsModalOpen(false); // Close the modal
    setModalImage(null); // Clear the image source
  };

  // Styles for the modal
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.7)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9000,
    },
    modal: {
      position: "relative",
      maxWidth: "90%",
      maxHeight: "90%",
      backgroundColor: "white",
      padding: "20px",
      borderRadius: "8px",
      boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
    },
    closeButton: {
      position: "absolute",
      top: "10px",
      right: "10px",
      padding: "5px 10px",
      backgroundColor: "red",
      color: "white",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
    },
  };

  return (
    <>
      {isLoading && <Loader />}
      <Container fluid className="mt-4">
        <ToastContainer autoClose={3000} />
        <Tabs
          defaultActiveKey="investments"
          id="order-history-tabs"
          className="justify-content-center">
          {/* ================= Investments Tab =================== */}
          <Tab eventKey="investments" title="Investments">
            <h4 className="text-center text-primary mt-4">
              Approved Investments
            </h4>
            <div className="history-table-container mt-4">
              <h5 className="text-warning mb-3">
                <strong>Total Investment:</strong> ₹
                {totalInvestment.toLocaleString()}
              </h5>
              <Table responsive className="history-table">
                <thead className="history-table-head">
                  <tr>
                    <th className="history-th">Deposit Date</th>
                    <th className="history-th">Deposit Mode</th>
                    <th className="history-th">Amount</th>
                    <th className="history-th">Status</th>
                    <th className="history-th">Proof</th>
                  </tr>
                </thead>
                <tbody className="history-table-body">
                  {currentItems.length > 0 ? (
                    currentItems.map((deposit, index) => (
                      <tr key={index} className="history-row">
                        <td className="history-td">
                          {new Date(deposit.requestedAt).toLocaleDateString(
                            "en-GB"
                          )}
                        </td>
                        <td className="history-td">{deposit.deposit_mode}</td>
                        <td className="history-td">
                          ₹{deposit.amount.toLocaleString()}
                        </td>
                        <td className="history-td">
                          <span
                            className={`badge ${
                              deposit.status === "Approved"
                                ? "bg-success"
                                : deposit.status === "Pending"
                                ? "bg-warning text-dark"
                                : "bg-danger"
                            }`}>
                            {deposit.status}
                          </span>
                        </td>
                        <td className="history-td">
                          <img
                            src={deposit.image_proof}
                            alt="proof"
                            width="50"
                            height="50"
                            onClick={() => {
                              openModal(deposit.image_proof);
                            }}
                            style={{ cursor: "pointer", borderRadius: "6px" }}
                          />
                        </td>
                      </tr>
                    ))
                  ) : isLoading ? (
                    <tr>
                      <td className="history-td" colSpan="8">
                        <ShimmerLoader width="100%" height="30px" />
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td className="history-td" colSpan="8">
                        No deposits found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
              {/* Pagination */}
              <div className="pagination-container custom-pagination">
                <Pagination>
                  {Array.from({ length: totalPages }, (_, pageIndex) => (
                    <Pagination.Item
                      key={pageIndex}
                      active={currentPage === pageIndex + 1}
                      onClick={() => setCurrentPage(pageIndex + 1)}
                      className="pagination-item">
                      {pageIndex + 1}
                    </Pagination.Item>
                  ))}
                </Pagination>
              </div>
            </div>
          </Tab>
          {/* ================= Returns Tab =================== */}
          <Tab eventKey="returns" title="Returns">
            <div className="history-table-container mt-4">
              <h5 className="text-warning mb-3">
                <strong>Returns History</strong>
              </h5>
              <Table responsive className="history-table">
                <thead className="history-table-head">
                  <tr>
                    <th className="history-th">Date</th>
                    <th className="history-th">Deposited Amount</th>
                    <th className="history-th">Lock Period</th>
                    <th className="history-th">Months Done</th>
                    <th className="history-th">Deposit + Return</th>
                    <th className="history-th">Returns</th>
                    <th className="history-th">Time Left</th>
                    <th className="history-th">Status</th>
                    {/* <th className="history-th">Old Age</th> */}
                    {/* <th className="history-th">Withdraw Period Selected</th> */}
                    <th className="history-th">Withdraw</th>
                  </tr>
                </thead>
                <tbody className="history-table-body">
                  {currentItems.length > 0 ? (
                    currentItems.map((deposit, index) => (
                      <tr key={index} className="history-row">
                        <td className="history-td">
                          {new Date(deposit.requestedAt).toLocaleDateString(
                            "en-GB"
                          )}
                        </td>
                        <td className="history-td">
                          ₹{deposit.amount.toLocaleString()}
                        </td>
                        <td className="history-td">
                          {deposit.timePeriod} Months
                        </td>
                        <td className="history-td">
                          {deposit.completedMonths}
                        </td>
                        <td className="history-td">
                          ₹{deposit.returnAmount || 0}
                        </td>
                        <td className="history-td">
                          ₹{deposit.particularReturn}
                        </td>
                        <td className="history-td">{deposit.timeLeft}</td>
                        <td className="history-td">
                          <span
                            className={`badge ${
                              deposit.paymentStatus === "Approved"
                                ? "bg-success"
                                : deposit.paymentStatus === "Pending"
                                ? "bg-warning text-dark"
                                : "bg-danger"
                            }`}>
                            {deposit.paymentStatus}
                          </span>
                        </td>
                        {/* <td className="history-td"> {deposit.oldAge ? "true" : "false"} </td> */}
                        {/* <td className="history-td">  {deposit.withdrawPeriodSelected ? "true" : "false"} </td> */}
                        <td className="history-td">
                          {deposit?.oldAge ||
                          deposit?.withdrawPeriodSelected ? (
                            <button
                              className="withdraw-btn btn-sm"
                              onClick={() =>
                                navigate("/partialWithdraws", {
                                  state: { id: deposit.id },
                                })
                              }>
                              Withdraw
                            </button>
                          ) : deposit.returnStatus === "Pending" &&
                            !deposit.withdraw ? (
                            <button
                              className="btn btn-secondary btn-sm"
                              disabled>
                              Waiting
                            </button>
                          ) : deposit.returnStatus === "Completed" &&
                            !deposit.withdraw ? (
                            <button
                              className="withdraw-btn btn-sm"
                              onClick={() =>
                                withdrawReq(
                                  deposit.deposit_mode,
                                  deposit.returnAmount,
                                  deposit.id,
                                  deposit.amount,
                                  deposit.particularReturn,
                                  deposit.completedMonths
                                )
                              }
                              disabled={isLoading}>
                              {loading ? "Submitting..." : "Withdraw"}
                            </button>
                          ) : (
                            <button className="btn btn-success btn-sm" disabled>
                              Done
                            </button>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : isLoading ? (
                    <tr>
                      <td className="history-td" colSpan="10">
                        <ShimmerLoader width="120%" height="30px" />
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td className="history-td" colSpan="10">
                        No deposits found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
              {/* Pagination */}
              <div className="pagination-container custom-pagination">
                <Pagination>
                  {Array.from({ length: totalPages }, (_, pageIndex) => (
                    <Pagination.Item
                      key={pageIndex}
                      active={currentPage === pageIndex + 1}
                      onClick={() => setCurrentPage(pageIndex + 1)}
                      className="pagination-item">
                      {pageIndex + 1}
                    </Pagination.Item>
                  ))}
                </Pagination>
              </div>
            </div>
          </Tab>
        </Tabs>
      </Container>
      {isModalOpen && (
        <div style={modalStyles.overlay}>
          <div style={modalStyles.modal}>
            <button style={modalStyles.closeButton} onClick={closeModal}>
              x
            </button>
            <img
              src={`${modalImage}`}
              alt="Modal Image"
              style={{ width: "100%", height: "85vh" }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default OrderHistoryPage;
